var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronFillTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52863 5.19518C7.78893 4.93488 8.21065 4.935 8.47102 5.19518L12.471 9.19518C12.6617 9.38584 12.7187 9.67262 12.6155 9.92174C12.5124 10.1706 12.2698 10.3327 12.0003 10.3329H4.00031C3.7307 10.3329 3.48731 10.1708 3.3841 9.92174C3.28092 9.67263 3.33798 9.38584 3.52863 9.19518L7.52863 5.19518Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronFillTop);
export default __webpack_public_path__ + "static/media/chevron-fill-top.e48701fbc0d282ff0ff704d401ae5a1e.svg";
export { ForwardRef as ReactComponent };